import React, { useState } from 'react';
import { Input, Button, Checkbox, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

const { Title, Text } = Typography;

const SIDEBAR_BG = '#1A3C7A';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email || !password) {
      message.warning('Please enter both email and password');
      return;
    }
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      const code = err?.code || '';
      if (code === 'auth/user-not-found' || code === 'auth/wrong-password' || code === 'auth/invalid-credential') {
        message.error('Invalid email or password');
      } else if (code === 'auth/too-many-requests') {
        message.error('Too many attempts. Please try again later.');
      } else {
        message.error('Sign in failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      {/* Left panel */}
      <div
        style={{
          flex: '0 0 44%',
          background: `linear-gradient(135deg, ${SIDEBAR_BG} 0%, #2B5EAA 50%, #4A72A8 100%)`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          padding: '0px 64px',
          position: 'relative',
          overflow: 'hidden',
          textAlign: 'left',
        }}
      >
        <div style={{
          position: 'absolute', top: -100, left: -100,
          width: 380, height: 380, borderRadius: '50%',
          background: 'rgba(255,255,255,0.04)',
        }} />
        <div style={{
          position: 'absolute', bottom: -140, left: -80,
          width: 480, height: 480, borderRadius: '50%',
          background: 'rgba(255,255,255,0.03)',
        }} />
        <div style={{
          position: 'absolute', top: '35%', right: -120,
          width: 320, height: 320, borderRadius: '50%',
          background: 'rgba(255,255,255,0.025)',
        }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: 420 }}>
          <img
            src="/5c-logo.png"
            alt="5C Network"
            style={{ height: 68, marginBottom: 48, filter: 'brightness(0) invert(1)' }}
          />
          <Title style={{
            color: '#fff', fontSize: 48, fontWeight: 800, margin: '0 0 16px 0',
            letterSpacing: 2, fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            WELCOME
          </Title>
          <Title level={2} style={{
            color: 'rgba(255,255,255,0.9)', fontWeight: 600, margin: '0 0 28px 0',
            fontSize: 26, fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            5C Audit Dashboard
          </Title>
          <Text style={{
            color: 'rgba(255,255,255,0.55)', fontSize: 16, lineHeight: 1.8,
            display: 'block', fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            Enterprise quality assurance for AI radiology.
            Benchmarking Bionic AI interpretations against
            radiologist-signed reports in real time.
          </Text>
        </div>
      </div>

      {/* Right panel */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#fff',
          padding: '40px 24px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 400 }}>
          <Title level={2} style={{
            color: SIDEBAR_BG, textAlign: 'center', marginBottom: 44,
            fontWeight: 700, fontSize: 30, fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            Sign in
          </Title>

          <div style={{ marginBottom: 22 }}>
            <Text strong style={{ color: '#555', fontSize: 13, display: 'block', marginBottom: 8, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              <UserOutlined style={{ marginRight: 6 }} />
              User Name
            </Text>
            <Input
              size="large"
              placeholder="Enter your email"
              autoComplete="off"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{ borderRadius: 8, borderColor: '#d9d9d9', height: 46, fontSize: 15 }}
            />
          </div>

          <div style={{ marginBottom: 22 }}>
            <Text strong style={{ color: '#555', fontSize: 13, display: 'block', marginBottom: 8, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              <LockOutlined style={{ marginRight: 6 }} />
              Password
            </Text>
            <Input.Password
              size="large"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{ borderRadius: 8, borderColor: '#d9d9d9', height: 46, fontSize: 15 }}
            />
          </div>

          <div style={{ marginBottom: 32 }}>
            <Checkbox
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            >
              <Text style={{ color: '#888', fontSize: 13, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Remember me</Text>
            </Checkbox>
          </div>

          <Button
            type="primary"
            size="large"
            block
            loading={loading}
            onClick={handleSubmit}
            style={{
              height: 48,
              borderRadius: 8,
              background: SIDEBAR_BG,
              fontWeight: 600,
              fontSize: 16,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}
          >
            Sign In
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Login;
